module.exports = __webpack_public_path__ + "img/blue.852abc2f.svg";